<template>
  <div>
    <div class="col-xs-12">
      <div class="uca-form">
        <div v-if="!matriculado" id="uca-form-content" class="uca-form-content row">
          <div class="col-xs-12">
            <h2 class="form-title">Menú principal</h2>
            <br/>
            <div class="alert alert-info text-center" style="font-size: 18px;">
              <strong>{{ alumno.sexo === 'M' ? 'Bienvenida' : 'Bienvenido' }} al Portal de la PAU</strong><br/>
              Elige entre las opciones disponibles:
            </div>
          </div>
          <div class="col-xs-12 opcionessolicitud">
            <div class="col-sm-6 col-xs-12 col-md-4">
              <div class="enlaceopcion">
                <div v-if="alumno.plazoMatricula && !alumno.tieneMatriculaActual">
                  <router-link :to="{name: 'matricula'}" style="display: block;">
                    <div class="interes_icon">
                      <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                    </div>
                    <div class="menu_text">Matrícula</div>
                  </router-link>
                </div>
                <div v-else>
                  <div class="opciondisabled">
                    <div class="interes_icon">
                      <i class="fa fa-ban" aria-hidden="true"></i>
                    </div>
                    <div class="menu_text">Matrícula</div>
                  </div>
                </div>
              </div>
              <div v-if="alumno.tieneMatriculaActual">
                <div v-if="alumno.fechaMatriculaActual">
                  <router-link :to="{name: 'alumno'}" class="btn btn-xs btn-success" title="Consultar matrícula"><i class="fa fa-file"></i>
                    Matrícula formalizada: {{ new Date(alumno.fechaMatriculaActual).toLocaleString('es-ES') }}
                  </router-link>
                </div>
                <div v-else>
                  <router-link :to="{name: 'alumno'}" class="btn btn-xs btn-success" title="Consultar matrícula"><i class="fa fa-file"></i>
                    Matrícula formalizada (consultar)
                  </router-link>
                </div>
              </div>
              <div v-else></div>
            </div>
            <div class="col-sm-6 col-xs-12 col-md-4">
              <div class="enlaceopcion">
                <div v-if="alumno.tieneMatricula || alumno.tieneMatriculaActual">
                  <a :href="URL_RECIBOS" style="display: block;" target="_blank">
                    <div class="interes_icon">
                      <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                    </div>
                    <div class="menu_text">Plataforma de pago</div>
                  </a>
                </div>
                <div v-else>
                  <div class="opciondisabled">
                    <div class="interes_icon">
                      <i class="fa fa-ban" aria-hidden="true"></i>
                    </div>
                    <div class="menu_text">Plataforma de pago</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-xs-12 col-md-4">
              <div class="enlaceopcion">
                <div v-if="alumno.tieneMatricula">
                  <router-link :to="{name: 'alumno'}" style="display: block;">
                    <div class="interes_icon">
                      <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                    </div>
                    <div class="menu_text">Calificaciones</div>
                  </router-link>
                </div>
                <div v-else>
                  <div class="opciondisabled">
                    <div class="interes_icon">
                      <i class="fa fa-ban" aria-hidden="true"></i>
                    </div>
                    <div class="menu_text">Calificaciones</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--Pantalla de salida de automatrícula-->
        <div v-else id="uca-form-content" class="uca-form-content row">
          <div class="col-xs-12">
            <h2 class="form-title">Solicitud de Matrícula en la PAU</h2>
            <br/>
            <div class="alert alert-success text-center">
              Has completado tu solicitud de matrícula.<br/>
              En breve recibirás un correo electrónico de confirmación.
            </div>
            <div v-if="recibo && recibo !== '0€'" class="alert alert-info text-center">
              <p>A continuación no olvides pagar el recibo para poder presentarte a las pruebas.<br>
                Para entrar a la plataforma de pago, utiliza el mismo usuario y clave que has usado para matricularte.</p>
              <br/>
              <a class="btn btn-primary" href="#" title="Ir a la plataforma de pago" @click.prevent="salir(true)">
                <i class="fa fa-angle-double-right"></i> Ir a la plataforma de pago <br>(Importe del recibo: <strong>{{ recibo }}</strong>)
              </a>
            </div>
            <div v-if="!recibo || !recibo.endsWith('€')" class="alert alert-danger text-center">
              <p>IMPORTANTE: Un problema ha impedido generar el recibo. Ponte en contacto cuanto antes
                con <a href="mailto:acceso@uca.es">acceso@uca.es</a> para subsanarlo.</p>
            </div>
            <div v-if="situacionEspecial" class="alert alert-warning text-center">
              <p>
                IMPORTANTE: La Universidad de Cádiz consultará telemáticamente los datos de discapacidad o el título de familia numerosa del
                estudiante que alegue dicha condición en su matrícula, a menos que el/la interesado/a nos indique su oposición a dicha consulta
                a través de correo electrónico a acceso@uca.es y en él, además deberá acreditar documentalmente dicha condición.
              </p>
            </div>
            <div class="alert alert-warning text-center">
              <p>
                La Universidad de Cádiz podrá utilizar sus resultados académicos con fines estadísticos.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- Indicador de carga -->
    <div ref="carga" v-if="$apollo.loading">
      <h3 style="display: block; text-align: center; margin-bottom: 30px; margin-top: 50px;">Cargando...</h3>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import {quitarErrorGeneral} from "../error";

export default {
  name: "menu-entrada",
  props: {
    dni: String,
    sello: Number,
    matriculado: Boolean,
    recibo: String,
    situacionEspecial: Boolean,
  },
  data() {
    return {
      alumno: Object,
      URL_RECIBOS: process.env.VUE_APP_GESTION_RECIBOS_URL
    }
  },
  apollo: {
    alumno: {
      query: gql`query($dni: String!, $sello: Int!) {
                alumno(dni: $dni, sello: $sello) {
                  sexo
                  plazoMatricula
                  tieneMatricula
                  tieneMatriculaActual
                  fechaMatriculaActual
                }
            }`,
      variables() {
        return {
          dni: this.dni,
          sello: this.sello
        }
      },
      fetchPolicy: 'network-only',
      skip() {
        return !this.dni || this.sello === null;
      },
      error() {
        this.$emit('aviso', 'Ha habido un error. Pruebe más tarde.');
      },
    },
  },
  mounted() {
    if (!this.dni) {
      this.$router.push({name: 'login'});
    }
    else {
      quitarErrorGeneral();
    }
  },
  methods: {
    salir(redirigir=false) {
      // Quito el token de sesión para que no pueda volver atrás y recuperar una sesión abierta.
      // eslint-disable-next-line no-undef
      sessionStorage.removeItem(this.$nombreToken);
      if (redirigir) {
        // eslint-disable-next-line no-undef
        window.location.href = this.URL_RECIBOS;
      }
      else {
        this.$router.push({name: 'login'});
      }
    }
  },
}
</script>

<style scoped>

</style>